import styled from "styled-components";
import { darkModeColors } from "../../consts";
import { device } from "../../services";
import { Paragraph2, WrapperContainer } from "../../components";

export const TablePaginationWrapper = styled(WrapperContainer)`
  @media screen and ${device.tablet} {
    gap: 16px !important;
  }
`;

export const PaginationInfoText = styled(Paragraph2)`
  font-weight: 500;
  font-size: 14px;
  line-height: 26px;

  color: ${darkModeColors.RAISIN_80_RAISIN_20};
`;

export const PaginationInputWrapper = styled(WrapperContainer)`
  input {
    height: 32px;
  }
`;
